/**-------------------------------  Copyright ---------------------------------
This software has been developed by Orange Labs TGI/OLS/SOFT
Copyright (c) Orange Labs 2018

COPYRIGHT    : This file is the property of Orange Labs.
Copyright Orange Labs 2018, All Rights Reserved

This software is the confidential and proprietary information of Orange Labs.

You shall not disclose such Confidential Information and shall use it only
in accordance with the terms of the license agreement you entered into with
Orange Labs.

AUTHORS      : Orange Labs  TGI/OLS/SOFT
EMAIL        : soft.cybersec@orange.com
-----------------------------------------------------------------------------*/

import {Component, Prop, Vue} from 'vue-property-decorator'
import {AnalysisVO} from '@/valueObjects/AnalysisVO'
import MessageBox from '@/components/shared/MessageBox'
import {AnalysisService} from '@/services/AnalysisService'
import AnalysisServiceMixin from '@/services/AnalysisServiceMixin'
import {INFO_MESSAGE_TYPE} from '@/utils/constants'

@Component({
    components: {
        MessageBox,
    },
    mixins: [AnalysisServiceMixin],
})
export default class AnalysisInteractiveSession extends Vue {

    private message = 'interactive session has been closed'
    private messageType = INFO_MESSAGE_TYPE
    private analysisService: AnalysisService
    private finished = 0

    @Prop()
    private analysis: AnalysisVO

    private get interactiveConnection(): string {
        return this.analysis.interactiveConnection
    }

    private get analysisIsOnGoing(): boolean {
        return !this.analysis.dynamicAnalysisIsFinished
    }

    private clearMessage() {
        this.message = ''
    }

    private async stopSession(): Promise<void> {
        this.finished = 1
        try {
            await this.analysisService.stopInteractiveSession(this.analysis)
        } catch (e) {
            const errorMessage = `An error prevented to stop the interactive session: ${e.errorMessage}`
            this.$emit('exception', errorMessage)
        }
    }

    private switchFrame() {
        this.$router.push({name: 'analysis-summary', params: { analysisId: this.analysis.id.toString()}})
    }

    private isFinished() {
        if (this.finished) {
            return 'is-loading'
        } else {
            return this.finished}
    }
}
